<template>
  <el-container
    class="userManagement-box"
    v-loading="loading"
    direction="vertical"
  >
    <div class="search-x" v-if="!loading && hasData">
      <PopulationCard
        :infoData="populationInfo"
        title="人口学信息"
      ></PopulationCard>
      <PopulationCard :infoData="healthInfo" title="健康信息"></PopulationCard>
      <InfoCard title="生活方式" :infoData="lifeInfo"></InfoCard>
    </div>
    <el-empty v-else description="暂无数据"></el-empty>
  </el-container>
</template>
<script>
import {
  getArchive,
  getHValueInfoToBV2,
  getUserModuleDoc,
  getUserModuleDocV2,
} from "@/config/healthApi.js";
import PopulationCard from "../health/components/PopulationCard.vue";
import InfoCard from "../health/components/InfoCard.vue";
export default {
  components: {
    PopulationCard,
    InfoCard,
  },
  data() {
    return {
      loading: true,
      hasData: false,
      populationInfo: [], // 人口学信息
      healthInfo: [], // 健康信息
      lifeInfo: {}, // 生活方式
      monitorData: {}, // 健康监测
      assessData: {}, // 健康评估
    };
  },
  mounted() {
    this.initData();
    this.getHealthData();
  },
  methods: {
    async initData() {
      this.loading = true;
      this.hasData = false;
      try {
        let res = null;
        let { isChannelArchive, phone } = this.$store.state.healthDocUser;
        if (isChannelArchive) {
          res = await getArchive({
            userId: this.$store.state.healthDocUser.userId,
          });
        } else {
          res = await getHValueInfoToBV2({
            phoneNumber: phone,
          });
        }
        if (res && res.code == 200 && Array.isArray(res.data) && res.data.length) {
          // 按 baseDataType 取值，避免依赖不稳定的数组下标
          const byType = {};
          res.data.forEach((item) => {
            if (item && item.baseDataType) {
              byType[item.baseDataType] = item.baseDataValue || {};
            }
          });
          const pop =
            byType["人口学信息"] ||
            byType["人口学"] ||
            (res.data[2] && res.data[2].baseDataValue) ||
            {};
          const health =
            byType["健康信息"] ||
            (res.data[1] && res.data[1].baseDataValue) ||
            {};
          this.populationInfo = this.formatData("popolation", pop);
          this.healthInfo = this.formatData("", health);
          this.hasData = true;
        }
      } catch (e) {
        this.hasData = false;
      } finally {
        this.loading = false;
      }
    },
    formatData(type, val) {
      let dataItemList =
        type == "popolation"
          ? [
              {
                key: "姓名",
              },
              {
                key: "性别",
              },
              {
                key: "出生日期",
              },
              {
                key: "年龄",
              },
              {
                key: "国籍",
              },
              {
                key: "籍贯",
              },
              {
                key: "证件",
                type: "table",
                width: "100%",
              },
              {
                key: "联系方式",
                type: "table",
                width: "100%",
              },
              {
                key: "户籍地址",
              },
              {
                key: "现住址",
              },
              {
                key: "民族",
              },
              {
                key: "紧急联系人",
                type: "list3",
                width: "100%",
              },
              {
                key: "婚姻状况",
              },
              {
                key: "文化程度",
              },
              {
                key: "常住类型",
              },
              {
                key: "医疗费支付方式",
                value: "--",
              },
              {
                key: "职业",
              },
              {
                key: "工作单位",
              },
              {
                key: "家庭年人均收入",
                value: "--",
              },
              {
                key: "个人年收入",
                value: "--",
              },
            ]
          : [
              {
                key: "家族史关系疾病",
                showTitle: "家族史",
                type: "list2",
                isNotHigh: true,
                width: "100%",
              },
              {
                key: "疾病史名称",
                showTitle: "疾病史",
                width: "100%",
              },
              {
                key: "过敏史",
                showTitle: "过敏史",
              },
              {
                key: "用药史",
                showTitle: "用药史",
              },
              {
                key: "手术史（部位）",
                showTitle: "手术史",
                type: "list2",
                width: "100%",
              },
              {
                // 此数据为特殊处理  数据类型和显示不一致
                key: "毒物种类",
                showTitle: "危害因素接触史",
              },
              {
                key: "外伤史",
                showTitle: "外伤史",
                type: "list2",
                width: "100%",
                isNotHigh: true,
              },
              {
                key: "输血史",
                showTitle: "输血史",
                type: "list2",
                width: "100%",
                isNotHigh: true,
              },
              {
                key: "残疾情况",
                showTitle: "残疾情况",
                value: "--",
              },

              {
                key: "体检频次",
                showTitle: "体检频次",
                value: "--",
              },
              {
                key: "生活环境",
                showTitle: "生活环境",
                type: "table",
                width: "100%",
              },
              {
                key: "月经生育史",
                showTitle: "月经生育史",
                type: "table",
                width: "100%",
              },
            ];
      dataItemList.forEach((item) => {
        const cell = val && val[item.key];
        if (!cell) {
          item.value = "--";
          return;
        }
        if (item.type == "table") {
          let arr = (cell.dataSubitemShow || []).filter(
            (ele) => ele.baseDataValue
          );
          item.value = arr.length ? arr : "--";
        } else if (item.type == "list3") {
          // let dataSubitemShow = [
          //   {
          //     dataItem: "联系人姓名",
          //     baseDataValueArray: ["刘海国", "姚梦辰"],
          //     dataItemCode: "000",
          //   },
          //   {
          //     dataItem: "联系人关系",
          //     baseDataValueArray: ["父亲", "母亲"],
          //     dataItemCode: "001",
          //   },
          //   {
          //     dataItem: "联系人电话",
          //     baseDataValueArray: ["123", "456"],
          //     dataItemCode: "002",
          //   },
          // ];
          let length = (cell.dataSubitemShow || []).length;
          let dataItem1 = cell.dataSubitemShow && cell.dataSubitemShow[0];
          let dataItem2 = cell.dataSubitemShow && cell.dataSubitemShow[1];
          let dataItem3 = cell.dataSubitemShow && cell.dataSubitemShow[2];
          let newItemArray = [];
          if (!dataItem1 || !dataItem1.baseDataValueArray) {
            item.value = "--";
          } else {
            for (let i = 0; i < dataItem1.baseDataValueArray.length; i++) {
              let newItem = {};
              newItem.name = {
                value: dataItem1.baseDataValueArray[i],
                dataItemCode: dataItem1.dataItemCode,
                dataItem: dataItem1.dataItem,
              };
              newItem.value1 = {
                value: dataItem2 && dataItem2.baseDataValueArray
                  ? dataItem2.baseDataValueArray[i]
                  : "",
                dataItemCode: dataItem2 && dataItem2.dataItemCode,
                dataItem: dataItem2 && dataItem2.dataItem,
              };
              newItem.value2 = {
                value: dataItem3 && dataItem3.baseDataValueArray
                  ? dataItem3.baseDataValueArray[i]
                  : "",
                dataItemCode: dataItem3 && dataItem3.dataItemCode,
                dataItem: dataItem3 && dataItem3.dataItem,
              };
              newItemArray.push(newItem);
            }
            item.value = newItemArray;
            item.length = length;
          }
        } else if (item.type == "list2") {
          if (!cell.dataSubitemShow) {
            item.value = "--";
            return;
          }
          let length = cell.dataSubitemShow.length;
          let dataItem1 = cell.dataSubitemShow[0];
          let dataItem2 = cell.dataSubitemShow[1];
          let newItemArray = [];
          if (!dataItem1 || !dataItem1.baseDataValueArray) {
            item.value = "--";
          } else {
            for (let i = 0; i < dataItem1.baseDataValueArray.length; i++) {
              let newItem = {};
              newItem.name = {
                value: dataItem1.baseDataValueArray[i],
                dataItemCode: dataItem1.dataItemCode,
                dataItem: dataItem1.dataItem,
              };
              newItem.value1 = {
                value: dataItem2 && dataItem2.baseDataValueArray
                  ? dataItem2.baseDataValueArray[i]
                  : "",
                dataItemCode: dataItem2 && dataItem2.dataItemCode,
                dataItem: dataItem2 && dataItem2.dataItem,
              };
              newItemArray.push(newItem);
            }
            item.value = newItemArray;
            item.length = length;
          }
        } else {
          item.value = cell;
        }
      });
      return dataItemList;
    },
    getHealthData() {
      let { isChannelArchive, profileId, customerAppId, phone } =
        this.$store.state.healthDocUser;
      let p1 = "";
      let p2 = "";
      let p3 = "";
      if (isChannelArchive) {
        p1 = getUserModuleDoc({
          userId: this.$store.state.healthDocUser.userId,
          moduleName: "生活方式",
        });
        p2 = getUserModuleDoc({
          userId: this.$store.state.healthDocUser.userId,
          moduleName: "健康监测",
        });
        p3 = getUserModuleDoc({
          userId: this.$store.state.healthDocUser.userId,
          moduleName: "健康评估",
        });
      } else {
        p1 = getUserModuleDocV2({
          phoneNumber: phone,
          moduleName: "生活方式",
        });
        p2 = getUserModuleDocV2({
          phoneNumber: phone,
          moduleName: "健康监测",
        });
        p3 = getUserModuleDocV2({
          phoneNumber: phone,
          moduleName: "健康评估",
        });
      }
      Promise.all([p1, p2, p3])
        .then((res) => {
          if (res[0].code == 200) {
            this.lifeInfo = res[0].data || {};
          } else {
            this.lifeInfo = {};
          }
          if (res[1].code == 200) {
            this.monitorData = res[1].data || {};
          } else {
            this.monitorData = {};
          }
          if (res[2].code == 200) {
            this.assessData = res[2].data || {};
          } else {
            this.assessData = {};
          }
        })
        .catch((error) => {
          this.lifeInfo = {};
          this.monitorData = {};
          this.assessData = {};
        });
    },
  },
};
</script>
<style type="text/scss" lang="scss" scoped>
@import "@/assets/css/color.scss";
.userManagement-box {
  min-height: 300px;
  .search-x {
    min-height: 120px;
    flex-shrink: 0;
    padding-top: 20px;
  }
  .cont-x {
    flex: 1;
    flex-shrink: 0;
  }
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.el-row {
  padding-left: 20px;
}
.el-col {
  margin-bottom: 20px;
}
.grid-label {
  display: inline-block;
  vertical-align: top;
}

.title {
  height: 30px;
  line-height: 30px;
  margin-bottom: 40px;
  font-weight: bold;
  padding-left: 20px;
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 8px;
    background-color: $theme;
  }
}
.grid-box {
  border: 1px solid #ebebeb;
  border-bottom: none;
  margin-left: 100px;
  .group-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
      display: inline-block;
      font-size: 14px;
      width: 130px;
      height: 28px;
      text-align: left;
      line-height: 28px;
      border-bottom: 1px solid #ebebeb;
      padding-left: 10px;
      &.item-label {
        background-color: #f2f2f2;
      }
      &.item-value {
        border-left: 1px solid #ebebeb;
      }
    }
  }
}
.el-empty {
  margin-top: 80px;
}
</style>
